/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  TimeWeightedStaking,
  TimeWeightedStakingInterface,
} from "../../contracts/TimeWeightedStaking";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "AddressEmptyCode",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "AddressInsufficientBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "FailedInnerCall",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "b",
        type: "uint256",
      },
    ],
    name: "Lock_BalanceOverflow",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "a",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "b",
        type: "uint256",
      },
    ],
    name: "Lock_BalanceUnderflow",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
    ],
    name: "Lock_InactiveStake",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "neededAmount",
        type: "uint256",
      },
    ],
    name: "Lock_InsufficientBalance",
    type: "error",
  },
  {
    inputs: [],
    name: "Lock_InvalidToken",
    type: "error",
  },
  {
    inputs: [],
    name: "Lock_NativeTransferFailed",
    type: "error",
  },
  {
    inputs: [],
    name: "ReentrancyGuardReentrantCall",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "SafeCastOverflowedUintToInt",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "SafeERC20FailedOperation",
    type: "error",
  },
  {
    inputs: [],
    name: "TimeWeightedLock_WeightOverflow",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "amount",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "StakeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "weightedAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "WeightUpdated",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getLockAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getStakeData",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "activeFrom",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "staker",
            type: "address",
          },
          {
            internalType: "contract IERC20",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct ILock.StakeData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getWeightedLockAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getWeightedStakeData",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "active",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "activeFrom",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakeWeight",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastUpdate",
            type: "uint256",
          },
        ],
        internalType: "struct ITimeWeightedLock.WeightedStakeData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "lock",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "totalStaked",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "unlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TimeWeightedStakingConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TimeWeightedStakingConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TimeWeightedStaking__factory extends ContractFactory {
  constructor(...args: TimeWeightedStakingConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      TimeWeightedStaking & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(
    runner: ContractRunner | null
  ): TimeWeightedStaking__factory {
    return super.connect(runner) as TimeWeightedStaking__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TimeWeightedStakingInterface {
    return new Interface(_abi) as TimeWeightedStakingInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): TimeWeightedStaking {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as TimeWeightedStaking;
  }
}
